import React from 'react';
import { BasePopup } from '../../../../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../../../../ui/popups/Popup/InfoTooltip/index.js';
import styles from './index.module.scss.js';

const Tooltip = ({ anchor, children }) => /* @__PURE__ */ React.createElement(
  BasePopup,
  {
    anchor,
    showEvent: "hover",
    gap: 8,
    horizontalAlignment: "right",
    verticalAlignment: "center",
    kind: "none",
    spacing: "none",
    className: styles.box
  },
  children
);

export { Tooltip };
//# sourceMappingURL=index.js.map
